import { render, staticRenderFns } from "./MarketLocationDelete.vue?vue&type=template&id=48663572"
import script from "./MarketLocationDelete.vue?vue&type=script&lang=js"
export * from "./MarketLocationDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports